<div class="h-100 d-flex flex-column justify-content-center align-items-center text-center">
  <img class="access-denied-image" src="./assets/images/error-404.png" alt="">
  <p class="access-denied-paragraph">
    Looks like the page you were looking for is <b>under construction</b> or <b>not found</b>.
  </p>
  <div class="submit-btn mt-4">
    <button mat-button class="create-btn" routerLink="/dashboard">
      <mat-icon style="font-size:21px;padding-right:30px">arrow_back</mat-icon>
      Back to Home
    </button>
  </div>
</div>